import { t } from "i18next";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import useMapStore from "@/store/mapStore";

function Offers() {
  const ads = useMapStore((state) => state.ads);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <h1 className="mb-10 text-3xl font-bold">{t("offers")}</h1>
      <Carousel className="w-4/5">
        <CarouselContent>
          {ads.map((ad, index) => (
            <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
              <img
                src={ad.url}
                alt={ad.name}
                className="h-full w-full object-cover"
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="-left-16 h-12 w-12 border-primary text-primary hover:border-primary/60 hover:text-primary/60" />
        <CarouselNext className="-right-16 h-12 w-12 border-0 bg-primary text-white hover:bg-primary/70 hover:text-white" />
      </Carousel>
    </div>
  );
}

export default Offers;
